/** モバイル絞り込みドロワー: 各行は button[data-mobile-facet-toggle] と .is-open で開閉 */
(function () {
  const ROOT = '.mobile-facets';

  function filterRoot(el) {
    return el.closest(`${ROOT} .mobile-facets__details.js-filter`);
  }

  function syncDrawerFooterVisibility() {
    document.querySelectorAll('.mobile-facets__inner').forEach((inner) => {
      inner.classList.toggle(
        'mobile-facets__inner--facets-submenu-open',
        Boolean(inner.querySelector('.mobile-facets__details.is-open')),
      );
    });
  }

  function setInnerOpen(root, open) {
    if (!root) return;
    root.classList.toggle('is-open', open);
    const btn = root.querySelector('[data-mobile-facet-toggle]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    const panel = root.querySelector('.mobile-facets__submenu');
    if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    syncDrawerFooterVisibility();
  }

  document.addEventListener(
    'shopify:mobile-facets:sync-submenu-footer',
    syncDrawerFooterVisibility,
  );

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest(`${ROOT} [data-mobile-facet-toggle]`);
    if (toggle) {
      const root = filterRoot(toggle);
      if (!root) return;
      event.preventDefault();
      setInnerOpen(root, !root.classList.contains('is-open'));
      return;
    }

    const back = event.target.closest(`${ROOT} .mobile-facets__close-button`);
    if (back) {
      const root = filterRoot(back);
      if (!root || !root.classList.contains('is-open')) return;
      event.preventDefault();
      setInnerOpen(root, false);
      root.querySelector('[data-mobile-facet-toggle]')?.focus();
    }
  });
})();
